const PREFIX = 'ERROR'

export enum ErrorCategory {
    NO_ERROR,
    GENERIC,
    LOGIN,
    MONITOR,
}

enum ErrorConstants {
    // SESSION
    RESET_ERROR,
    CLIENT_IS_NOT_LOGGED_IN,

    //COMMON
    GENERIC_ERROR,
}

export const CLIENT_IS_NOT_LOGGED_IN = PREFIX + '_' + ErrorConstants.CLIENT_IS_NOT_LOGGED_IN;
export const RESET_ERROR = PREFIX + '_' + ErrorConstants.RESET_ERROR;

export const GENERIC_ERROR = PREFIX + '_' + ErrorConstants.GENERIC_ERROR;
